import { createAdaptiveDropdown } from 'components/createAdaptiveDropdown';

import CbbDropdownV2 from './CbbDropdownV2';

import rightArrow from '../../../public/images/arrow-rightV2.svg';

// See createAdaptiveDropdown for the shared implementation.
// Base classes/icon are copied from CbbDropdownV2 so both breakpoints match.
const CbbAdaptiveDropdownV2 = createAdaptiveDropdown(CbbDropdownV2, {
  rootBaseClassName:
    'custom-dropdown flex items-center no-focus relative bg-white box-border justify-between xl:mr-0 pl-2 pr-[2px] py-[10px] border cursor-pointer border-beige-dark',
  labelClassName: 'flex-1 min-w-0',
  arrowIcon: rightArrow,
  arrowSize: 14,
});

export default CbbAdaptiveDropdownV2;
